//请求（数据库）
import { takeEvery } from "redux-saga/effects";
import homeServicesApi, {
  REQ_INDEX_HEALTHY_DATA,
  REQ_VISION_DATA,
  REQ_HISTORY_INDEX_DATA,
} from "../services/homeServices/api";
import healthyDataApi, {
  REQ_ALL_DATA,
  INIT_REQ_ALL_DATA,
  REQ_RECORD_DATA,
} from "../services/healthyDataServices/api";
import healthyHistoryApi, {
  REQ_ALLERGIC_HISTORY_DATA,
  REQ_DISEASES_HISTORY_DATA,
  REQ_FAMILY_HISTORY_DATA,
  REQ_OTHER_HISTORY,
  REQ_SURGERY_PARTS,
  REQ_SURGERY_HISTORY_DATA,
} from "../services/healthyHistoryServices/api";

import visionHealthApi, {
  REQ_ALL_VISION_DATA,
  INIT_REQ_ALL_VISION_DATA,
  REQ_VISION_ITEM_DATA,
} from "../services/visionHealthDataServices/api";

import reportApi, {
  REQ_CHINESE_MEDICINE_REPORT,
  REQ_CHINESE_MEDICINE_DATA,
  REQ_WEST_LIST_DATA,
} from "../services/reportServices/api";

function * mySaga () {
  // 接受action传递的任务
  yield takeEvery (REQ_INDEX_HEALTHY_DATA, homeServicesApi.getIndexHealthyData);//首页健康数据的请求
  yield takeEvery (REQ_VISION_DATA, homeServicesApi.getIndexVisionData);//首页视力数据
  yield takeEvery (REQ_HISTORY_INDEX_DATA, homeServicesApi.getHealthyIndexData);//首页历史
  yield takeEvery (REQ_RECORD_DATA, healthyDataApi.getRecordData);
  yield takeEvery (INIT_REQ_ALL_DATA, healthyDataApi.getAllData);//初始化全部数据
  yield takeEvery (REQ_ALL_DATA, healthyDataApi.getAllData);//请求全部数据
  yield takeEvery (INIT_REQ_ALL_VISION_DATA, visionHealthApi.getAllData);//初始化全部数据
  yield takeEvery (REQ_ALL_VISION_DATA, visionHealthApi.getAllData);//请求全部数据
  yield takeEvery (REQ_VISION_ITEM_DATA, visionHealthApi.getVisionItemData);
  yield takeEvery (REQ_FAMILY_HISTORY_DATA, healthyHistoryApi.getFamilyHistoryData);//获取历史数据
  yield takeEvery (REQ_DISEASES_HISTORY_DATA, healthyHistoryApi.getDiseasesHistoryData);
  yield takeEvery (REQ_ALLERGIC_HISTORY_DATA, healthyHistoryApi.getAllergicHistoryData);//
  yield takeEvery (REQ_SURGERY_PARTS, healthyHistoryApi.getSurgeryParts);//手术部位列表
  yield takeEvery (REQ_SURGERY_HISTORY_DATA, healthyHistoryApi.getSurgeryList);//手术列表
  yield takeEvery (REQ_OTHER_HISTORY, healthyHistoryApi.getOtherHistory);//烟酒史
  yield takeEvery (REQ_CHINESE_MEDICINE_REPORT, reportApi.getChineseMedicineReport);
  yield takeEvery (REQ_CHINESE_MEDICINE_DATA, reportApi.getChineseMedicineData);
  yield takeEvery (REQ_WEST_LIST_DATA, reportApi.getWestMedicineDataList);//西医数据

  //...
}

export default mySaga;
